"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_GROUP = void 0;
var PRODUCT_GROUP = {
  BUTTON__PRODUCT_GROUP: 'productGroup-button-toggle',
  BUTTON__ADD_NEW_GROUP: 'productGroup-button-addNewProductGroup',
  INPUT__SEARCH: 'productGroup-input-search',
  TEXT__RESULT: 'productGroup-span-result',
  BUTTON__EDIT: 'productGroup-button-edit',
  BUTTON__REMOVE: 'productGroup-button-remove',
  ADD_EDIT_MODAL: {
    INPUT__GROUP_NAME: 'productGroupModal-input-groupName',
    BUTTON__CANCEL: 'productGroupModal-button-cancel',
    BUTTON__SAVE: 'productGroupModal-button-save'
  },
  REMOVE_MODAL: {
    BUTTON__CANCEL: 'removeProductGroup-button-cancel',
    BUTTON__REMOVE: 'removeProductGroup-button-remove'
  }
};
exports.PRODUCT_GROUP = PRODUCT_GROUP;